import React, { Component } from "react";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Config from "API/Config";
import { setImage } from "../../store/actions";
import Resizer from "react-image-file-resizer";
import { axiosApi as axios } from "helpers/api_helper";
import Cropper from "react-easy-crop";

const getCroppedImg = (imageSrc, cropPixels) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = cropPixels.width;
      canvas.height = cropPixels.height;

      ctx.drawImage(
        image,
        cropPixels.x,
        cropPixels.y,
        cropPixels.width,
        cropPixels.height, // Source
        0,
        0,
        cropPixels.width,
        cropPixels.height // Destination
      );

      canvas.toBlob(blob => {
        resolve(blob);
      }, "image/jpeg");
    };
    image.onerror = error => reject(error);
  });
};

class FileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFiles: [],
      isUploading: false,
      uploadedFile: null,
      crop: { x: 0, y: 0 },
      zoom: 1,
      aspect: 1 / 1,
      croppedArea: null,
      croppedAreaPixels: null,
      image: null,
      cropModal: false,
    };
  }

  componentDidMount() {
    const { image } = this.props;
    if (image) {
      this.setState({
        selectedFiles: [{ name: "", preview: image, url: image }],
        image,
      });
    }
  }

  onCropChange = crop => {
    this.setState({ crop });
  };

  onCropAreaChange = croppedArea => {
    this.setState({ croppedArea });
  };

  onZoomChange = zoom => {
    this.setState({ zoom });
  };

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({ croppedAreaPixels });
  };

  onCloseClick = () => {
    this.setState({ cropModal: false });
  };

  resizeFile = file =>
    new Promise(resolve => {
      Resizer.imageFileResizer(
        file,
        1000,
        1000,
        "JPEG",
        100,
        0,
        uri => {
          resolve(uri);
        },
        "file"
      );
    });

  handleAcceptedFiles = async files => {
    const file = files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.setState({
          image: reader.result,
        });
      };
      reader.readAsDataURL(file);
      this.setState({ cropModal: true });
    }
    // files.forEach(file => {
    //   this.handleFileUpload(file);
    // });
  };

  handleFileUpload = async file => {
    if (!this.state.image || !this.state.croppedAreaPixels) return;
    this.setState({ isUploading: true });

    const croppedBlob = await getCroppedImg(
      this.state.image,
      this.state.croppedAreaPixels
    );

    const formData = new FormData();
    formData.append("file", croppedBlob, "cropped-image.jpg");

    const token = (axios.defaults.headers.common["Authorization"] =
      localStorage.getItem("token"));

    axios({
      crossdomain: true,
      method: "post",
      url: `${Config.Server.API_BASE_URL}/upload`,
      data: formData,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    })
      .then(response => {
        if (response.data.result) {
          const reponseData = {
            url: response.data.data.imageUrl,
          };
          let fileToSave;
          if (this.state.uploadedFile?.length > 1) {
            fileToSave = `${this.state.uploadedFile},${response.data.data.fileUrl}`;
          } else {
            fileToSave = response.data.data.fileUrl;
          }
          if (this.props.handlePrivateImage) {
            this.props.onFileUploaded(fileToSave);
          } else {
            this.props.setImage(fileToSave);
          }

          this.setState({
            uploadedFile: fileToSave,
            isUploading: false,
          });
          return reponseData;
        } else {
        }
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.setState({ isUploading: false, cropModal: false });
      });
  };

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  render() {
    const { isUploading } = this.state;
    return (
      <div>
        <Modal
          isOpen={this.state.cropModal}
          toggle={this.onCloseClick}
          centered={true}
        >
          <ModalBody>
            <div
              style={{
                position: "relative",
                width: "100%",
                height: this.state.image ? 400 : 0,
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 80,
                  backgroundColor: "black",
                }}
              >
                <Cropper
                  image={this.state.image}
                  crop={this.state.crop}
                  zoom={this.state.zoom}
                  aspect={this.state.aspect}
                  onCropChange={this.onCropChange}
                  onCropComplete={this.onCropComplete}
                  onZoomChange={this.onZoomChange}
                  onCropAreaChange={this.onCropAreaChange}
                  style={{
                    backgroundColor: "black",
                  }}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            {isUploading ? (
              <div className="spinner-border text-primary m-1" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            ) : this.state.image ? (
              <Button
                color="primary"
                onClick={() => this.handleFileUpload(this.state.image)}
              >
                {`Crop and Upload`}
              </Button>
            ) : null}
          </ModalFooter>
        </Modal>
        <Dropzone
          maxFiles={this.props.maxFiles ? this.props.maxFiles : 1}
          multiple={this.props.maxFiles ? this.props.maxFiles !== 1 : false}
          accept="image/jpeg,image/png,image/webp"
          onDrop={acceptedFiles => this.handleAcceptedFiles(acceptedFiles)}
        >
          {({ getRootProps, getInputProps }) => (
            <div className="dropzone">
              <div className="dz-message needsclick mt-2" {...getRootProps()}>
                <input {...getInputProps()} />

                <h4>Drop files here or click to upload.</h4>
              </div>
            </div>
          )}
        </Dropzone>

        {this.state.uploadedFile && (
          <div className="dropzone-previews mt-3" id="file-previews">
            <Card
              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
              key={"-file"}
            >
              <div className="p-2">
                <Row className="align-items-center">
                  <Col className="col-auto">
                    <img
                      data-dz-thumbnail=""
                      height="400"
                      className="avatar-xxl rounded bg-light"
                      alt={"eventImage"}
                      src={this.state.uploadedFile}
                    />
                  </Col>
                </Row>
              </div>
            </Card>
          </div>
        )}
      </div>
    );
  }
}

FileUpload.propTypes = {
  token: PropTypes.any,
  setImage: PropTypes.func,
  maxFiles: PropTypes.number,
  image: PropTypes.string,
  handlePrivateImage: PropTypes.bool,
  onFileUploaded: PropTypes.func,
};

const mapStateToProps = ({ Login }) => ({
  token: Login.token,
});

export default withRouter(connect(mapStateToProps, { setImage })(FileUpload));
